import { getAuthHeaders } from "@/lib/auth-fetch";
import { API_BASE } from "@/lib/utils";

export async function previewAiSegment({ prompt, eventId }) {
  const res = await fetch(`${API_BASE}/api/admin/ai/segments/preview`, {
    method: "POST",
    headers: { "content-type": "application/json", ...getAuthHeaders() },
    body: JSON.stringify({ prompt, event_id: eventId }),
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(body?.detail || `Preview failed (${res.status})`);
  return body;
}

export async function saveAiSegment({ prompt, eventId, name = "" }) {
  const res = await fetch(`${API_BASE}/api/admin/ai/segments/save`, {
    method: "POST",
    headers: { "content-type": "application/json", ...getAuthHeaders() },
    body: JSON.stringify({ prompt, event_id: eventId, name }),
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(body?.detail || `Save failed (${res.status})`);
  return body;
}

export async function listSavedSegments(eventId) {
  const res = await fetch(`${API_BASE}/api/admin/ai/segments/${encodeURIComponent(eventId)}`, {
    headers: getAuthHeaders(),
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) return [];
  return body.segments || [];
}

export async function scoreAttendees(eventId, limit = 500) {
  const res = await fetch(`${API_BASE}/api/admin/ai/attendees/score`, {
    method: "POST",
    headers: { "content-type": "application/json", ...getAuthHeaders() },
    body: JSON.stringify({ event_id: eventId, limit }),
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(body?.detail || `Scoring failed (${res.status})`);
  return body;
}

export async function loadAttendeeScores(eventId) {
  const res = await fetch(`${API_BASE}/api/admin/ai/attendees/score/${encodeURIComponent(eventId)}`, {
    headers: getAuthHeaders(),
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) return {};
  return body.scores || {};
}

export async function askAiChatbot({ message, eventId = null }) {
  const res = await fetch(`${API_BASE}/api/admin/ai/chatbot`, {
    method: "POST",
    headers: { "content-type": "application/json", ...getAuthHeaders() },
    body: JSON.stringify({ message, event_id: eventId }),
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(body?.detail || `Chat failed (${res.status})`);
  return body;
}

export async function matchSponsorAttendees({ eventId, sponsorName, sponsorGoals = "" }) {
  const res = await fetch(`${API_BASE}/api/admin/ai/sponsors/match`, {
    method: "POST",
    headers: { "content-type": "application/json", ...getAuthHeaders() },
    body: JSON.stringify({
      event_id: eventId,
      sponsor_name: sponsorName,
      sponsor_goals: sponsorGoals,
    }),
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(body?.detail || `Match failed (${res.status})`);
  return body;
}
